import React from "react";
import { useSearchParams } from "react-router-dom";
import AirlineDirectory from "./AirlineDirectory";
import FlightResultsPage from "./FlightResultsPage";

export default function FlightsHub() {
  const [searchParams] = useSearchParams();
  const hasSearch =
    searchParams.has("origin") &&
    searchParams.has("dest") &&
    searchParams.has("departDate");

  return hasSearch ? <FlightResultsPage /> : <AirlineDirectory />;
}
